import { FontSize200, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const fourCornersCateogryTileStyles = {
  imageContainerSx: {
    display: "flex",
    justifyContent: "center",
    width: "80%",
    span: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      aspectRatio: "1/1",
      width: { lg: "80%", md: "126px", xs: "78px" },
      // Adjusted for responsive design; overwrites responsiveStyles.ts
      height: { lg: "80%", md: "126px", xs: "78px" }
    }
  },
  imageSx: {
    width: "80%"
  },
  linkSx: {
    minWidth: "100%",
    padding: SpaceXxs
  },
  titleSx: {
    fontSize: `${FontSize200}`
  }
};
export {
  fourCornersCateogryTileStyles
};
